// KPI Excel çıktısı indirme (M16 T22) — blob kalıbı `api/frameworks.ts exportFrameworkVersion`
// ile aynı: fetch (cookie) → Content-Disposition'dan dosya adı → <a download>. `api/kpi.ts`'e
// dokunulmadı (başka iş düzenliyor); bu dosya yalnız iki indirme ucunu taşır.

import type { KpiLang } from "@mahir/shared";
import { buildKpiExportQuery } from "../lib/kpi-export-ui";
import { ApiError } from "./client";

const XLSX_FALLBACK = "kpi.xlsx";

/** Ortak xlsx indirme (iç + portal kopyası `api/portal-kpi.ts` bunu kullanır). */
export async function downloadKpiXlsx(path: string, fallbackName: string): Promise<void> {
  const res = await fetch(`/api/v1${path}`, { credentials: "include" });
  if (!res.ok) {
    let message = "Excel çıktısı alınamadı";
    let code = "export_failed";
    try {
      const body = (await res.json()) as { error?: string; message?: string };
      if (body.message) message = body.message;
      if (body.error) code = body.error;
    } catch {
      // gövde JSON değil
    }
    throw new ApiError(res.status, code, message);
  }
  const disposition = res.headers.get("content-disposition") ?? "";
  const match = /filename="([^"]+)"/.exec(disposition);
  const filename = match?.[1] ?? fallbackName;
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Canlı set — GET /kpi/sets/:setId/export.xlsx?years=…&lang=en (yıllar boşsa sunucu varsayılanı;
 * `lang` yok/"tr" ise gösterge etiketleri katalogdan — TODO-KPI-09).
 */
export async function downloadKpiSetExcel(
  setId: string,
  years: number[] = [],
  lang?: KpiLang,
): Promise<void> {
  await downloadKpiXlsx(
    `/kpi/sets/${setId}/export.xlsx${buildKpiExportQuery(years, lang)}`,
    XLSX_FALLBACK,
  );
}

/** Belge snapshot'ı — GET /documents/:id/kpi.xlsx (kpi_snapshot yoksa 404 `no_kpi_snapshot`). */
export async function downloadDocumentKpiExcel(documentId: string): Promise<void> {
  await downloadKpiXlsx(`/documents/${documentId}/kpi.xlsx`, XLSX_FALLBACK);
}
